import {
    NOTIFICATION
} from "./type";

const initialState = {
    notificationDetails:[]
};

const NotificationReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case NOTIFICATION:
            return {
                ...state,
                notificationDetails: payload,
            };
        default:
            return {...state};
    }
};

export default NotificationReducer;